module.exports = __webpack_public_path__ + "img/upload-photo.a700a706.png";